import React from 'react'

import { Portlet, Button, Table, Row, Col } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as SocioService from 'services/socio.service'

import TiposDocumentoSocioConstant from 'constants/tiposDocumentoSocio'

import NuevoDocumentoModal from './modals/nuevo'

const formatFecha = fecha => {
  if (!fecha) return ''
  const d = new Date(fecha)
  return d.toLocaleString('es-PE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const DocumentosSection = ({ documentos, dispatch, idSocio }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarNuevoModal, setMostrarNuevoModal] = React.useState(false)

  const agregarDocumentoHandler = async ({ tipo, file, comentario }) => {
    if (idSocio) {
      // Modo edición: subir inmediatamente
      try {
        const { data } = await SocioService.agregarDocumentoxIdSocio(idSocio, { tipo, file, comentario })
        dispatch({
          type: 'agregar',
          payload: {
            _id: data._id,
            tipo: data.tipo,
            nombreArchivo: data.nombreArchivo,
            comentario: data.comentario,
            fechaCreacion: data.fechaCreacion
          }
        })
        __zariContext.snack('success', 'Documento adjuntado.')
      } catch (err) {
        const error = err && err.data && err.data.error
        __zariContext.snack('error', error || 'No se pudo adjuntar el documento.')
        return
      }
    } else {
      // Modo creación: guardar en memoria; se sube al crear el socio
      dispatch({
        type: 'agregar',
        payload: {
          tipo: tipo,
          nombreArchivo: file.name,
          comentario: comentario || null,
          file: file,
          pendiente: true
        }
      })
    }
    setMostrarNuevoModal(false)
  }

  const eliminarDocumentoHandler = async ({ _idFila, _id }) => {
    if (_id) {
      try {
        await SocioService.eliminarDocumentoSocio(_id)
        __zariContext.snack('success', 'Documento eliminado.')
      } catch (err) {
        const error = err && err.data && err.data.error
        __zariContext.snack('error', error || 'No se pudo eliminar el documento.')
        return
      }
    }
    dispatch({ type: 'eliminar', payload: { _idFila } })
  }

  const descargarDocumentoHandler = async ({ _id, nombreArchivo }) => {
    if (!_id) return
    try {
      const { data } = await SocioService.descargarDocumentoSocio(_id)
      const url = URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', nombreArchivo || 'documento')
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(url)
    } catch (err) {
      const error = err && err.data && err.data.error
      __zariContext.snack('error', error || 'No se pudo descargar el documento.')
    }
  }

  return (
    <>
      <Portlet>
        <Portlet.Body noPadding>
          <Row>
            <Col md={12} className='mb-2 text-right'>
              <Button onClick={() => setMostrarNuevoModal(true)}>Nuevo</Button>
            </Col>
          </Row>
          <Table.ClientSide
            headRows={[
              { label: 'TIPO' },
              { label: 'ARCHIVO' },
              { label: 'COMENTARIO' },
              { label: 'FECHA' },
              { label: '' }
            ]}
            filas={documentos}
            rowTemplate={row => {
              const tipoNombre = TiposDocumentoSocioConstant.__dictionary[row.tipo]?.nombre || row.tipo
              return (
                <Table.Row hover key={row._idFila}>
                  <Table.Cell>{tipoNombre}</Table.Cell>
                  <Table.Cell>
                    {row.nombreArchivo}
                    {row.pendiente ? (
                      <span className='badge badge-warning ml-2' style={{ fontSize: '0.7rem' }}>
                        Pendiente
                      </span>
                    ) : null}
                  </Table.Cell>
                  <Table.Cell>{row.comentario || '--'}</Table.Cell>
                  <Table.Cell>{row.fechaCreacion ? formatFecha(row.fechaCreacion) : '--'}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => {
                        const items = []
                        if (row._id) {
                          items.push(
                            <Table.Dropdown.Item
                              key='descargar'
                              handleClose={handleClose}
                              onClick={() => descargarDocumentoHandler(row)}
                            >
                              Descargar
                            </Table.Dropdown.Item>
                          )
                        }
                        items.push(
                          <Table.Dropdown.Item
                            key='eliminar'
                            handleClose={handleClose}
                            onClick={() => eliminarDocumentoHandler(row)}
                          >
                            Eliminar
                          </Table.Dropdown.Item>
                        )
                        return items
                      }}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )
            }}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarNuevoModal && (
        <NuevoDocumentoModal
          handleClose={() => setMostrarNuevoModal(false)}
          show={mostrarNuevoModal}
          agregarDocumento={agregarDocumentoHandler}
        />
      )}
    </>
  )
}

export default React.memo(DocumentosSection)
